/**
 * @param {Object} payload
 * @param {string} payload.customer - mandatory
 * @param {string} payload.streamId - mandatory
 * @param {string} payload.username - mandatory
 */
// For more information, check sis streaming integration docs - https://sisintegration.atlassian.net/wiki/spaces/SD/pages/7274899/Streaming+Integration
async function fetchStreamData (payload) {
  if (!payload.customer) throw new Error('Missing required parameter - "customer"')
  if (!payload.streamId) throw new Error('Missing required parameter - "streamId"')
  if (!payload.username) throw new Error('Missing required parameter - "username"')
  const params = new URLSearchParams(payload)
  const token = await generateToken(`?${params}`, '2117c4d821d64ad5f84d8ca05057408c')
  if (token) params.append('token', token)
  const url = `https://streamingapi.sis.tv/StreamingService/api/v2/stream`
  try {
    const response = await fetch(`${url}?${params}`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error(`fetchStreamData error: ${error}`)
  }
}

/**
 * @param {string} queryString- mandatory
 * @param {string} secretKey - mandatory
 */
async function generateToken (queryString, secretKey) {
  const encoder = new TextEncoder()
  const keyData = encoder.encode(secretKey)
  const msgData = encoder.encode(queryString)

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: { name: 'SHA-1' } },
    false,
    ['sign']
  )

  const signature = await window.crypto.subtle.sign('HMAC', cryptoKey, msgData)

  const hashArray = Array.from(new Uint8Array(signature))
  const fullHash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  const token = '0' + fullHash.substring(0, 20)

  return token
}

export default {
  fetchStreamData
}



// WEBPACK FOOTER //
// ./src/library/sisStreaming/index.js